import { get } from './shared';
import { isVideo } from 'helpers/fileTests';

export const presignedUrl = async (file: File) => {
  const url = isVideo(file)
    ? `api/attachments/presigned_url?content_type=${file.type}`
    : `attachments/cache/presign`;
  return await get(url);
};
